<template>
  <div class="row flex">
      <!-- <div class="md1">a</div> -->
      
      <div v-if="status_botoes" class="flex md12 va-card center">
        <div class="row flex text-center">

            <div v-on:click="trocar_component('iniciocomponent')" title="Inicio" class="flex flex-center mb3 icon-grid-container edit" style="flex-direction: column;">
              <div class="vuestic-icon mb-3 pt-1">
                <i class="ic va-icon fa fa-list-ul" style="font-size: 20px;"></i><br>Inicio
              </div>
            </div>

              <!-- <div v-on:click="trocar_component('calendariocomponent')" title="Calendario" class="flex flex-center mb3 icon-grid-container edit" style="flex-direction: column;">
              <div class="vuestic-icon mb-3 pt-1">
                <i class="ic va-icon fa fa-calendar" style="font-size: 20px;"></i>
                </div>
              </div> -->

            <div v-on:click="trocar_component('videoscomponent')" title="Video" class="flex flex-center mb3 icon-grid-container edit" style="flex-direction: column;">
              <div class="vuestic-icon mb-3 pt-1">
               <i class="ic va-icon vuestic-iconset vuestic-iconset-video" style="font-size: 20px;"></i><br>Videos
              </div>
              
            </div>

            <!-- <div v-on:click="trocar_component('audioscomponent')"  title="Audios" class="flex flex-center mb3 icon-grid-container edit" style="flex-direction: column;">
              <div class="vuestic-icon mb-3 pt-1">
                <i class="ic va-icon vuestic-iconset vuestic-iconset-music" style="font-size: 20px;"></i><br>Audios
              </div>
            </div> -->

            <div v-on:click="trocar_component('slidescomponent')" title="Aulas" class="flex flex-center mb3 icon-grid-container edit" style="flex-direction: column;">
              <div class="vuestic-icon mb-3 pt-1">
                <i class="va-icon fa fa-file-powerpoint-o" style="font-size: 20px;"></i><br>Aulas
              </div>
            </div>

            <div v-on:click="trocar_component('extrascomponent')" title="Extras" class="flex flex-center mb3 icon-grid-container edit"  style="flex-direction: column;">
              <div class="vuestic-icon mb-3 pt-1">
                <i class="ic va-icon vuestic-iconset vuestic-iconset-extras" style="font-size: 20px;"></i><br>Extras
              </div>
            </div>
       
            <!-- <div v-on:click="trocar_component('questionarioscomponent')" title="Questionarios" class="flex flex-center mb3 icon-grid-container edit" style="flex-direction: column;">
              <div class="vuestic-icon mb-3 pt-1">
                <i class="ic va-icon fa fa-pencil-square-o" style="font-size: 20px;"></i>
              </div>
            </div>

            <div v-on:click="trocar_component('notascomponent')" title="Notas" class="flex flex-center mb3 icon-grid-container edit" style="flex-direction: column;">
              <div class="vuestic-icon mb-3 pt-1">
                <i class="ic va-icon vuestic-iconset vuestic-iconset-ui-elements " style="font-size: 20px;"></i>
              </div>
            </div>

            <div v-on:click="trocar_component('chatcomponent')" title="Chat" class="flex flex-center mb3 icon-grid-container edit" style="flex-direction: column;">
              <div class="vuestic-icon mb-3 pt-1">
                <i class="ic va-icon fa fa-comments" style="font-size: 20px;"></i>
              </div>
            </div>
            -->
            <div v-on:click="trocar_component('forumcomponent')" title="Forum"  class="flex flex-center mb3 icon-grid-container edit"  style="flex-direction: column;">
              <div class="vuestic-icon mb-3 pt-1">
                <i class="ic va-icon fa fa-users" style="font-size: 20px;"></i><br>Forum
              </div>
            </div>
             
      </div>
      </div>

       <div class="row">

    
     
    <!-- <div class="flex md12"> -->
        <div class="flex md12" >         
         <!-- <va-card class="md12"> -->
            <component 
              v-bind:is="currentTabComponent"  
            ></component>
          <!-- </va-card> -->
        </div>
     
    </div> 


  </div>
</template>

<script>

 import slidescomponent from './components/slidesComponent/SlidesComponent'
 import audioscomponent from './components/audiosComponent/Audioscomponent'
 import calendariocomponent from './components/calendarioComponet/CalendarioComponent'
 import chatcomponent from './components/chatComponent/ChatPage'
 import videoscomponent from './components/videosComponent/VideoComponent'
 import extrascomponent from './components/Extras/ExtrasComponent'
 import forumcomponent from './components/ForumComponent/ForumComponent'
 import iniciocomponent from './components/inicioComponent/InicioComponent'
 import notascomponent from './components/notasComponent/NotasComponent'
 import questionarioscomponent from './components/questionariosComponent/QuestionariosComponent'
 import materias from './components/inicioComponent/Materias'
export default {
  components: {
    slidescomponent,
    audioscomponent,
    calendariocomponent,
    chatcomponent, 
    videoscomponent, 
    extrascomponent ,
    forumcomponent ,
    iniciocomponent ,
    notascomponent ,
    questionarioscomponent,
    materias
  },

  name: 'botoesinicial',
  data () {
    return {
      limpa: '',
      ListaDeMaterias: [
              {nameMat:'teste'},
              {nameMat:'test2'}
              ],
            object: {
              nameMat: 'nameMat'
            },

        SlidesComponent: {
              component:'slidescomponent',
              rota: {name: 'alunos/slides'}
            },
        Audioscomponent: {
              component:'audioscomponent',
              rota: {name: 'alunos/audios'}
            },
        CalendarioComponent: {
              component:'calendariocomponent',
              rota: {name: 'alunos/calendario'}
            },
        ChatComponent: {
              component:'chatcomponent',
              rota: {name: 'alunos/chat'}
            }, 
        VideoComponent: {
              component:'videoscomponent',
              rota: {name: 'alunos/videos'}
            }, 
        ExtrasComponent: {
              component:'extrascomponent'
            } ,
        ForumComponent: {
              component:'forumcomponent',
              rota: {name: 'alunos/forum'}
            } ,
        InicioComponent: {
              component:'iniciocomponent'
            } ,
        NotasComponent: {
              component:'notascomponent'
            } ,
        QuestionariosComponent: {
              component:'questionarioscomponent',
              rota: {name: 'alunos/questionarios'}
            },
         currentTab: 'iniciocomponent',
         perm: true,
    }
  },
  computed: {
    currentTabComponent () {
     //console.log(this.currentTab)
      return  this.currentTab.toLowerCase()

    },
    status_botoes(){    
        if (this.$store.state.datamateria.setmateria.status ==  1) {
         return this.status = true
        }
    
    }
  },

  methods: {
    trocar_component (value) {
      this.status = true
      this.currentTab = value
      
    }
 
  },
}
</script>

<style>
  .edit 
  {  
     width: 40px;
     height: 60px;
     border: solid 1px rgb(129, 127, 127); 
     margin: 0 -1px 0 0;
  }

  .edit:hover 
  {
    background-color: #6361f0;
    color: #fff;
  }


  .ic 
  {
    padding: 10px 0 0 0 ;
  }

</style>
